import React from 'react'

const OpNurseOrders = () => {
  return (
    <div className='mx-auto p-4'>
      OpNurseOrders
    </div>
  )
}

export default OpNurseOrders
